<template>
  <div class="Contact">
    <div class="formulier" v-show="!verzonden">
      <h1>Contactformulier</h1>
      <form action="javascript:void(0);" @submit="verzend();">
        <div class="fspan">
          <label class="flabel" for="inputNaam">Uw naam</label>
          <input id="inputNaam" name="naam" class="finput" maxlength="100" autofocus v-model="afzendernaam" />
        </div>

        <div class="fspan">
          <label class="flabel" for="inputEmail">Uw e-mailadres</label>
          <input id="inputEmail" type="email" class="finput" name="email" maxlength="250" v-model="afzendermail" />
        </div>

        <div class="fspan-high">
          <label class="flabel" for="inputBericht">Uw bericht</label>
          <textarea id="inputBericht" class="farea" maxlength="1000" name="bericht" v-model="bericht" ></textarea>
        </div>

        <div class="fspan">
          <label class="flabel" for="btnSend"></label>
          <input type="submit" value="Verzenden" />&nbsp;&nbsp;&nbsp;
          <router-link :to="{name: 'home'}"><input type="button" value="Annuleren" /></router-link>
        </div>
      </form>
    </div>
    <div class="verzonden" v-show="verzonden">
      <h1>Bericht verzonden</h1>
      <p>Hartelijk dank voor uw bericht. U ontvangt zo snel mogelijk antwoord.</p>
      <p>
      <router-link :to="{name: 'home'}"><input type="button" value="Terug" /></router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact",
  components: {},
  data() {
    return {
      verzonden: false,
      afzendernaam: '',
      afzendermail: '',
      bericht: ''
    };
  },
  methods: {
    verzend: function() {
      if (this.afzendernaam === "")
      {
        alert("Vul uw naam in.");
        return;
      }
      if (this.afzendermail === "")
      {
        alert("Vul uw e-mailadres in.");
        return;
      }
      
      var data = {
        afzendernaam: this.afzendernaam,
        afzenderemail: this.afzendermail,
        bericht: this.bericht
      };

      this.$http
        .post("../webservice/api/ContactForm/SendMail", data)
        .then(function() {
          this.verzonden = true;
        });
    }
  }
};
</script>

<style scoped>
.flabel {
  display: inline-block;
  width: 150px;
}

.finput {
  width: 300px;
}

.fspan {
  height: 25px;
  line-height: 25px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.fspan-high {
  height: 300px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.farea {
  width: 300px;
  height: 300px;
  vertical-align: top;
}
</style>